export function normalizeProgram(raw = {}) {
  return {
    id: Number(raw.id),
    name: raw.name || '',
    description: raw.description || '',
    price: Number(raw.price) || 0,
    sale_price: raw.sale_price !== null && raw.sale_price !== undefined ? Number(raw.sale_price) : null,
    much_for: raw.much_for || '',
    video: Boolean(raw.video),
    genre: raw.genre || '',
    files: Array.isArray(raw.files) ? raw.files : [],
    features: Array.isArray(raw.features) ? raw.features : [],
    crowds: Array.isArray(raw.crowds) ? raw.crowds : [],
    timings: Array.isArray(raw.timings) ? raw.timings : [],
    types: Array.isArray(raw.types) ? raw.types : [],
    short_description: raw.short_description || '',
    age: raw.age !== null && raw.age !== undefined ? raw.age : null
  };
}

export function isProgram(obj) {
  return obj && typeof obj === 'object' && 'id' in obj && typeof obj.name === 'string';
}

export default { normalizeProgram, isProgram };